import { NewLeaveApplicationForm } from "./_components/new-leave-application-form";

const AddLeaveApplicationOfEmployee = () => {
  return (
    <div className="p-2 md:h-[calc(100%-56px)] h-[calc(100vh-56px)]">
      <div className="h-full rounded-md">
        <NewLeaveApplicationForm />
      </div>
    </div>
  );
};

export default AddLeaveApplicationOfEmployee;
